import React from 'react';
import LegalLayout from './LegalLayout';

const Terms = () => (
  <LegalLayout title="Terms of Service" lastUpdated="2026-04-30">
    <p>
      These Terms govern your use of Gainrhino CRM (the "Service"), provided by
      Gainrhino ("we", "our", "us"). By creating an account or using the Service
      you agree to these Terms.
    </p>

    <h2 className="text-xl font-semibold text-gray-900 pt-4">1. Account</h2>
    <p>
      You must be at least 18 years old and authorised to bind the business you
      represent. Keep your credentials confidential — you are responsible for
      activity under your account.
    </p>

    <h2 className="text-xl font-semibold text-gray-900 pt-4">2. Acceptable use</h2>
    <p>You agree not to:</p>
    <ul className="list-disc pl-6 space-y-1">
      <li>Use the Service for unlawful purposes or to send unsolicited messages.</li>
      <li>Reverse engineer, scrape or attempt to disrupt the Service.</li>
      <li>Upload content you do not have the right to use.</li>
      <li>Use the Service to store or process special-category personal data (medical records, payment cards, government IDs) outside what its features explicitly support.</li>
    </ul>

    <h2 className="text-xl font-semibold text-gray-900 pt-4">3. Data ownership</h2>
    <p>
      You retain ownership of all data you upload or generate via the Service
      ("Customer Data"). We process Customer Data only to deliver the Service and
      as described in our <a href="/privacy" className="text-primary-600 hover:underline">Privacy Policy</a>.
    </p>

    <h2 className="text-xl font-semibold text-gray-900 pt-4">4. Third-party services</h2>
    <p>
      The Service integrates with third parties (Meta, NetSapiens, VoIP.ms,
      Google, OpenAI, Mistral AI). Your use of those integrations is also
      subject to their respective terms. We are not responsible for outages
      or changes on third-party platforms.
    </p>

    <h2 className="text-xl font-semibold text-gray-900 pt-4">5. Fees</h2>
    <p>
      Subscription fees, if any, are described in your order form or pricing page.
      Fees are non-refundable except where required by law.
    </p>

    <h2 className="text-xl font-semibold text-gray-900 pt-4">6. Service availability</h2>
    <p>
      We aim for high availability but do not guarantee uninterrupted access.
      Scheduled maintenance and emergency fixes may cause temporary downtime.
    </p>

    <h2 className="text-xl font-semibold text-gray-900 pt-4">7. Termination</h2>
    <p>
      Either party may terminate at any time. On termination, we will delete your
      data within 30 days of cancellation unless you ask us to retain it longer or
      legal requirements dictate otherwise.
    </p>

    <h2 className="text-xl font-semibold text-gray-900 pt-4">8. Liability</h2>
    <p>
      To the maximum extent permitted by law, our aggregate liability for any
      claim arising from the Service is limited to the fees paid by you in the
      twelve months preceding the claim.
    </p>

    <h2 className="text-xl font-semibold text-gray-900 pt-4">9. Changes</h2>
    <p>
      We may update these Terms from time to time. Material changes will be
      communicated by email or in-app notice at least 14 days in advance.
    </p>

    <h2 className="text-xl font-semibold text-gray-900 pt-4">10. Contact</h2>
    <p>
      Questions? Email{' '}
      <a href="mailto:info@gainrhino.com" className="text-primary-600 hover:underline">info@gainrhino.com</a>.
    </p>
  </LegalLayout>
);

export default Terms;
